import { SimpleGrid, Stack } from "@chakra-ui/react";
import FinancialMetric from "../../../../components/FinancialMetric";
import { SectionWrapper } from "../SectionWrapper";
import type { HTMLAttributes } from "react";
import React from "react";

// Metrics Data will use ticker in real implementation
interface KeyMetricsData {
  grossBurnRate?: string;
  debtToEquityRatio?: number;
  cashPosition?: string;
  currentRatio?: number;
  runway?: string;
  netBurnRate?: string;
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  keyMetricsData: KeyMetricsData;
}

export default function SectionKeyMetrics({ keyMetricsData, ...props }: Props) {
  const title = "Key Investment Metrics as of " + new Date().toLocaleDateString("en-US", { month: "short", year: "numeric" });
  return (
    <SectionWrapper title={title} {...props}>
      <SimpleGrid columns={3} spacing="1.5rem" p="1rem">
        <Stack spacing="1rem">
          <FinancialMetric title="Gross Burn Rate" value={keyMetricsData?.grossBurnRate} />
          <FinancialMetric title="Debt to Equity Ratio" value={keyMetricsData?.debtToEquityRatio} />
        </Stack>

        <Stack spacing="1rem">
          <FinancialMetric title="Cash Position" value={keyMetricsData?.cashPosition} />
          <FinancialMetric title="Current Ratio" value={keyMetricsData?.currentRatio} />
        </Stack>

        <Stack spacing="1rem">
          <FinancialMetric title="Runway" value={keyMetricsData?.runway} />
          <FinancialMetric title="Net Burn Rate" value={keyMetricsData?.netBurnRate} />
        </Stack>
      </SimpleGrid>
    </SectionWrapper>
  );
}
